// 261023 E3-P3h4a (FE) — vẽ «Chấm ✓ → Sửa vòng 1/2 … → Chấm lại» (mockup Rev 2.2 ảnh 20). Chỉ vẽ: dữ liệu/chữ ở `chainProgressView.ts` (chữ lấy nguyên từ BE).
import React from 'react';
import type { ChainRow } from './chainProgressView';

interface Props {
  rows: ChainRow[];
  /** Chú thích dưới các hàng (dải); bỏ qua ở hộp. */
  caption?: string | null;
  /** `box`: canh giữa dưới hộp «Máy đang chạy bước này» (nhiều hàng, vd ① nhiều quyển ⇒ vẫn in nhãn từng hàng); `band`: luôn có nhãn hàng bên trái. */
  variant: 'band' | 'box';
}

const ChainLoop: React.FC<Props> = ({ rows, caption, variant }) => {
  if (rows.length === 0) return null;
  return (
    <div className={`wb-lp-wrap wb-lp-${variant}`} aria-label="Tiến độ chấm và sửa">
      {rows.map((r) => (
        <div className="wb-lp" key={r.key}>
          {(variant === 'band' || rows.length > 1) && <b className="wb-lp-name">{r.label}</b>}
          {r.chips.map((c, i) => (
            <React.Fragment key={c.key}>
              {i > 0 && <span className="wb-lp-arrow" aria-hidden="true">→</span>}
              <span className={`wb-lp-sg wb-lp-${c.tone}`}>{c.text}{c.icon ? <span className="wb-lp-ic" aria-hidden="true"> {c.icon}</span> : null}</span>
            </React.Fragment>
          ))}
        </div>
      ))}
      {caption && <div className="wb-lp-cap">{caption}</div>}
    </div>
  );
};

export default ChainLoop;
